/* eslint-disable consistent-return */
/* eslint-disable no-undef */
const MAX_FILE_NAME = 20;

export const SUPPORTED_FILES = '.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.ppt,.pptx';

export const MIME_TYPES = {
  images: {
    jpg: ['image/jpg', 'image/jpeg', 'image/pjpeg'],
    png: 'image/png',
    gif: 'image/gif',
    svg: 'image/svg+xml',
  },
  documents: {
    doc: [
      'application/doc',
      'application/ms-doc',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    xls: [
      'application/excel',
      'application/vnd.ms-excel',
      'application/x-excel',
      'application/x-msexcel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    ppt: [
      'application/mspowerpoint',
      'application/powerpoint',
      'application/vnd.ms-powerpoint',
      'application/x-mspowerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
    pdf: 'application/pdf',
    csv: 'text/csv',
  },
  others: {
    zip: 'application/zip',
  },
};

export const getFileNameDisplay = (fileName) => {
  if (!fileName) return;

  let result = fileName;

  const parts = fileName.split('.');
  const name = parts[0];
  const extension = parts[1];

  if (name.length > MAX_FILE_NAME)
    result = `${name.substring(0, 10)}...${name.substring(
      name.length - 10,
      name.length
    )}.${extension}`;

  return result;
};

export const openFileURL = (url) => {
  if (url) window.open(url, '_blank');
};

export const downloadFile = (arrayBuffer, type) => {
  const blob = new Blob([arrayBuffer], { type });
  const url = URL.createObjectURL(blob);
  openFileURL(url);
};

export const downloadFileWithName = (arrayBuffer, type, fileName) => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';

  const blob = new Blob([arrayBuffer], { type });
  const url = window.URL.createObjectURL(blob);

  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const uploadFile = (file) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const arrayBuffer = event.target.result;
    downloadFile(arrayBuffer, file.type);
  };
  reader.readAsArrayBuffer(file);
};

export const onBufferingFile = (zipData, type = 'application/zip', fileName) => {
  const { buffer } = new Uint8Array([...zipData]);

  if (fileName) downloadFileWithName(buffer, type, fileName);
  else downloadFile(buffer, type);
};
export const onPreview = async (file, cb) => {
  let src = file.url;
  if (!src) {
    src = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  }
  if (cb) {
    cb(src);
  } else {
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  }
};
